/**
 * Investor contact-title enum (US-040) - values must match the backend's
 * Prisma `ContactTitle` enum members exactly (`common/constants` in the
 * Backend repo has no equivalent file; the enum lives in `schema.prisma`).
 */
export type ContactTitle =
  | 'managing_partner'
  | 'general_partner'
  | 'principal'
  | 'vice_president'
  | 'associate'
  | 'analyst'
  | 'other';

export const CONTACT_TITLE_OPTIONS: { value: ContactTitle; label: string }[] = [
  { value: 'managing_partner', label: 'Managing Partner' },
  { value: 'general_partner', label: 'General Partner' },
  { value: 'principal', label: 'Principal' },
  { value: 'vice_president', label: 'Vice President' },
  { value: 'associate', label: 'Associate' },
  { value: 'analyst', label: 'Analyst' },
  { value: 'other', label: 'Other' },
];

export function contactTitleLabel(value?: string | null): string | undefined {
  return CONTACT_TITLE_OPTIONS.find((o) => o.value === value)?.label ?? value ?? undefined;
}
